import { AutogenModelCarrierOfferList, AutogenRowCarrierOfferList } from "./autogen/AutogenModelCarrierOfferList";

export class ModelCarrierOfferList extends AutogenModelCarrierOfferList<RowCarrierOfferList> {
    constructor() {
        super(RowCarrierOfferList);
    }
}

export class RowCarrierOfferList extends AutogenRowCarrierOfferList {
}